import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08854f16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "career-perks" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode(" Our Technologies "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "Stack")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, [
    /*#__PURE__*/_createTextVNode(" We are always accepting new technologies to implement in our products "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" and services. Can't find the technology you are working with? No problem - teach us! ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "tech-list" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.perks, (perk) => {
          return (_openBlock(), _createElementBlock("div", {
            key: perk.icon,
            class: "technology"
          }, [
            _createElementVNode("img", {
              class: "icon",
              src: require(`@/assets/img/career/stack/${perk.icon}.svg`)
            }, null, 8, _hoisted_6),
            _createElementVNode("p", null, _toDisplayString(perk.title), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}